import { formatCurrency } from "../../helpers/estimateTotals";

export function formatBriefingCurrency(amount) {
  const value = Math.round(Number(amount || 0));
  if (value <= 0) {
    return null;
  }

  if (value >= 1000) {
    return `about ${formatCurrency(value)}`;
  }

  return formatCurrency(value);
}

export function formatBriefingHours(hours) {
  const value = Number(hours || 0);
  if (value <= 0) {
    return null;
  }

  const rounded = value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
  const label = value === 1 ? "hour" : "hours";
  return `${rounded} ${label}`;
}

export function pluralize(count, singular, plural = `${singular}s`) {
  const value = Number(count || 0);
  if (value === 1) {
    return `1 ${singular}`;
  }
  return `${value} ${plural}`;
}
